import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Upload, Settings, Server } from 'lucide-react';
import clsx from 'clsx';
import ImportUploadPage from './ImportUploadPage';
import ImportConfigPage from './ImportConfigPage';
import WorkersPage from './WorkersPage';

const TABS = [
  { key: 'upload', label: 'Importieren', icon: <Upload size={18} /> },
  { key: 'configs', label: 'Konfigurationen', icon: <Settings size={18} /> },
  { key: 'workers', label: 'Worker', icon: <Server size={18} /> },
];

export default function ImportCombinedPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'upload';

  const setTab = (key: string) => {
    setSearchParams({ tab: key });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-1 bg-white rounded-xl shadow-sm border border-gray-200 p-1">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={clsx(
              'flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
              tab === t.key
                ? 'bg-primary text-white shadow-sm'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50',
            )}
          >
            {t.icon}
            {t.label}
          </button>
        ))}
      </div>

      <div>
        {tab === 'upload' && <ImportUploadPage />}
        {tab === 'configs' && <ImportConfigPage />}
        {tab === 'workers' && <WorkersPage />}
      </div>
    </div>
  );
}
